module.exports = __webpack_public_path__ + "static/5-a47cc02492a0e846deb69ce9b94dd949.png";